/**
 * Class for deleting a pickup
 */
export class PickupDelete { 

    public rowVersion : string = '';

    constructor(rowVersion : string) {
        this.rowVersion = rowVersion;
    }
}
